import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import useParameters from "../parameters/useParameter";
import { Sparkle } from "./Sparkle";

export function CoachTab() {
  const { t } = useTranslation("topbar");

  const location = useLocation();
  const parameters = useParameters();
  if (parameters["coach.enabled"] !== true) {
    return null;
  }

  const active = location.pathname === "/coach";
  return (
    <li className={active ? "tab-active" : ""}>
      <NavLink to="/coach" className={() => (active ? "active" : "")} replace>
        <span className="main-tab__content-wrapper">
          <span>
            <Sparkle /> {t("COACH")}
          </span>
        </span>
      </NavLink>
    </li>
  );
}
